import styled from 'styled-components';
import { colors, typography } from '@insurancemenu/imenu-components-lib';

export const DependentsWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DependentLabelStyled = styled.span`
  ${typography.regular[14]}
  color: ${colors.neutral[900]};
`;

export const DependentsWarningMessageStyled = styled.span`
  ${typography.regular[14]}
  color: ${colors.neutral[900]};
  padding-bottom: 0.5rem;
`;
